export const getWixAdsHeight = () => document.querySelector('#WIX_ADS')?.clientHeight ?? 0
